import React, { useRef, useState, useEffect } from 'react'
import ReelPlayIcon from './reel-play-icon.svg'

const ReelVideo = ({
  src,
  title,
  wrapperClassName,
  videoClassName,
}) => {
  const childRefs = useRef(null)

  const [isPlaying, setIsPlaying] = useState(false)

  const pauseVideo = ({ target }) => {
    if (!childRefs.current?.contains(target)) {
      if (!childRefs.current?.childNodes[0].paused) {
        childRefs.current?.childNodes[0].pause()

        setIsPlaying(false)
      }
    }
  }

  useEffect(() => {
    document.body.addEventListener('click', pauseVideo)

    return () => {
      document.body.removeEventListener('click', pauseVideo)
    }
  }, [])

  const playReelVideo = () => {
    childRefs.current?.childNodes[0].play()
    setIsPlaying(true)
  }

  const pauseReelVideo = () => {
    childRefs.current?.childNodes[0].pause()
    setIsPlaying(false)
  }

  return (
    <div
    style={{position: "relative", height: "100%"}}
      className={wrapperClassName}
      role="presentation"
      ref={childRefs}
    >
      <video
      style={{width: "100%", height: "100%"}}
        className={videoClassName}
        src={`${src}#t=0.001`}
        title={title}
        preload="metadata"
        onClick={() =>
          childRefs.current?.childNodes[0].paused
            ? playReelVideo()
            : pauseReelVideo()
        }
        loop
        playsInline
      />

      <img
      style={{display: isPlaying ? "none" : "block", position: "absolute", margin: "auto", top: 0, bottom: 0, right: 0, left: 0}}
        src={ReelPlayIcon}
        alt="Reel Play Button"
        onClick={() => {
          childRefs.current?.childNodes[0].paused
            ? playReelVideo()
            : pauseReelVideo()
        }}
        width="55"
        height="55"
        role="button"
      />
    </div>
  )
}

export default ReelVideo
